import React from 'react';
import { Body } from '@edreamsodigeo/prisma-design-system';
import { Trans } from '@edreamsodigeo/frontend-core';
import { PriceStyle } from '../PriceStyle';

export const NeedAppSubtitleBoldStyle = ({ type, content }) => {
  return (
    <Body inline type={type} weight="medium">
      {content}
    </Body>
  );
};

export const MoreInfoBannerParag1Subtitle = ({ cap }) => {
  return (
    <Trans
      i18nKey="pricefreeze.moreinfo.coverage.trip.subtitle"
      components={{ price: <PriceStyle money={cap} rounded /> }}
    />
  );
};
export const MoreInfoBannerParag1SubtitleValuePropositionV2 = ({
  cap,
  deposit,
  days,
}) => {
  return (
    <Trans
      i18nKey="moreinfo.coverage.valueprop.subtitle"
      components={{
        price: <PriceStyle money={deposit} rounded />,
        days: `${days}`,
        cap: <PriceStyle money={cap} rounded />,
      }}
    />
  );
};
